import InputLabel from '@material-ui/core/InputLabel'
import Grid from 'components/Grid'
import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  width: 100%;
`
export const NomeSecao = styled.h1`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    font-weight: ${theme.font.extraBold};
    font-size: ${theme.font.sizes.medium};
  `}
  margin-bottom: 24px;
`

export const Label = styled(InputLabel)`
  margin-bottom: 8px;
  min-width: 352px;
`

export const GridCustomizado = styled(Grid)`
  ${media.lessThan('large')`
    display: grid;
    grid-template-columns: repeat(2,32%);
    grid-template-rows: repeat(3,1fr);
    grid-gap: 24px 56px;
    margin: 0 0 24px 0;
  `}
`
